import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { MODULE_CERTIFICATE_TYPES } from '@/app/routes';
import { useGetMaterialsQuery } from '@/lib/api/lookupsApi';
import { buildFacilityOptions } from '@/config/formOptions';
import { EMPTY_LIST } from '@/lib/utils';
import { useCurrentUser } from './useCurrentUser';
import { useTranslations } from './useTranslations';

/**
 * Props:
 *   stockCheck  offer-but-disable a site stocking none of the materials; the contract
 *               form is the one that opts out, since it picks its material afterwards
 */
export const useModuleLookups = ({ stockCheck = true } = {}) => {
  const t = useTranslations();
  const { module } = useParams();
  const certificateType = MODULE_CERTIFICATE_TYPES[module];
  const user = useCurrentUser();

  const sites = user?.sites ?? EMPTY_LIST;
  const backToBackAccounts = user?.backToBackAccounts ?? EMPTY_LIST;

  const { data: materials = EMPTY_LIST, isLoading: materialsLoading } =
    useGetMaterialsQuery(certificateType);

  const facilityOptions = useMemo(
    () =>
      buildFacilityOptions({
        sites,
        backToBackAccounts,
        materials: stockCheck ? materials : null,
        noMaterialsLabel: t('SHIPMENT_FORM_NO_MATERIAL_ASSIGNED'),
      }),
    [sites, backToBackAccounts, materials, stockCheck, t],
  );

  return {
    certificateType,
    sites,
    backToBackAccounts,
    materials,
    facilityOptions,
    materialsLoading,
  };
};
